var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useCallback } from 'react';
import { useNotificationContext } from './useNotificationContext';
/**
 * Hook for Notification Side Effect
 *
 * @example
 *
 * const notify = useNotify();
 * // simple message (info level)
 * notify('Level complete');
 * // specify level
 * notify('A problem occurred', { type: 'warning' })
 * // pass arguments to the translation function
 * notify('Deleted %{count} elements', { type: 'info', messageArgs: { smart_count: 23 } })
 * // show the action as undoable in the notification
 * notify('Post renamed', { type: 'info', undoable: true })
 */
export var useNotify = function () {
    var addNotification = useNotificationContext().addNotification;
    return useCallback(function (message, options) {
        if (options === void 0) { options = {}; }
        var _a = options.type, messageType = _a === void 0 ? 'info' : _a, notificationOptions = __rest(options, ["type"]);
        addNotification({
            message: message,
            type: messageType,
            notificationOptions: notificationOptions,
        });
    }, [addNotification]);
};
//# sourceMappingURL=useNotify.js.map